import { Alert, Empty, Skeleton } from 'antd'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { fetchPublicExhibitions, fetchPublicResearchList, type PublicApiError, type PublicPublicationSummary } from './publicApi'

export default function PublicPublicationListPage({
  workspaceSlug,
  siteSlug,
  kind,
  title,
}: {
  workspaceSlug: string
  siteSlug: string
  kind: 'exhibition' | 'research'
  title: string
}) {
  const [rows, setRows] = useState<PublicPublicationSummary[] | null>(null)
  const [error, setError] = useState<string | null>(null)
  const base = `/site/${workspaceSlug}/${siteSlug}`
  const listPath = kind === 'exhibition' ? 'exhibitions' : 'research'

  useEffect(() => {
    setRows(null)
    setError(null)
    const fetcher = kind === 'exhibition' ? fetchPublicExhibitions : fetchPublicResearchList
    fetcher(workspaceSlug, siteSlug)
      .then((r) => setRows(r.data.items))
      .catch((err) => setError((err as PublicApiError).message))
  }, [workspaceSlug, siteSlug, kind])

  if (error) return <div className="pub-page"><Alert type="error" message={error} showIcon /></div>

  return (
    <div className="pub-page">
      <h1>{title}</h1>
      {rows === null ? (
        <Skeleton active paragraph={{ rows: 4 }} />
      ) : rows.length === 0 ? (
        <Empty className="pub-empty" description={`暂无${title}`} />
      ) : (
        <div className="pub-grid" style={{ marginTop: 24 }}>
          {rows.map((r) => (
            <Link key={r.slug} to={`${base}/${listPath}/${r.slug}`} className="pub-card">
              <div className="pub-card-cover">{r.cover_url && <img src={r.cover_url} alt={r.label} />}</div>
              <div className="pub-card-body">
                <p className="pub-card-title">{r.label}</p>
                <p className="pub-card-meta">{r.venue || r.author || (r.start_date && `${r.start_date} – ${r.end_date}`)}</p>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  )
}
